import { connect } from 'react-redux'
import DesktopPanel from './DesktopPanel'
import { getDesktopActivity, getDesktopEvents } from './desktop.actions'

const mapStateToProps = ({
  media: {
    desktop: { activity, events },
  },
}) => ({
  loading: activity.loading || events.loading,
  error: activity.error ? activity.error : events.error ? events.error : false,
  events: events.data || [],
  appUse: activity.data ? activity.data.appUse : [],
  interactionStates: activity.data ? activity.data.interactionStates : [],
})

const mapDispatchToProps = dispatch => ({
  async updateContactId(contactId, isRootRecording) {
    const desktopActivity = dispatch(getDesktopActivity(contactId, isRootRecording))
    const desktopEvents = dispatch(getDesktopEvents(contactId, isRootRecording))
    await desktopActivity
    await desktopEvents
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(DesktopPanel)
